import script from "./SingleVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleVideo.vue?vue&type=script&setup=true&lang=js"

import "./SingleVideo.vue?vue&type=style&index=0&id=ca3aef56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca3aef56"]])

export default __exports__